export class Heatmap {
  constructor(data) {
    this.latitude = data?.latitude ?? 0;
    this.longitude = data?.longitude ?? 0;
    this.weight = data?.weight ?? 0;
  }

  getLatitude() {
    return this.latitude;
  }

  getLongitude() {
    return this.longitude;
  }

  getWeight() {
    return this.weight;
  }
}

export class CompanyHeatmap {
  constructor(data) {
    this.companyId = data?.companyId ?? null;
    this.locations = Array.isArray(data?.locations) 
      ? data.locations.map(loc => new Heatmap(loc))
      : [];
    this.maxIntensity = data?.maxIntensity ?? 0.1;
  }

  getCompanyId() {
    return this.companyId;
  }

  getLocations() {
    return this.locations;
  }

  getMaxIntensity() {
    return this.maxIntensity;
  }
}

export class HeatmapData {
  constructor(data) {
    this.data = Array.isArray(data) 
      ? data.map(item => new CompanyHeatmap(item))
      : [];
  }

  getData() {
    return this.data;
  }
}
